import type { DisplayOperationColumnEntity } from 'src/entities/DisplayOperationColumn.entity';

/**
 * 運行指示書の明細 1 行。
 * origin は「元: 101-3」（log_web_issues#353）。表示列ではないので列配列とは別に持つ。
 */
// Why not 列配列に内部キーの列として混ぜる: 列キーは会社の任意入力列の名前なので、どんな内部キーでも同名の列と衝突しうる
export type DirectionRow = { attrs: DisplayOperationColumnEntity[]; origin: string | null };

export function mergeBySameRow(input: DirectionRow[]): DirectionRow[] {
  const groups = new Map<string, DirectionRow>();

  input.forEach(({ attrs: row, origin }) => {
    // 一致判定するデータで識別キーを作る（「元」が違う明細は表示列が同じでも合算しない）
    const identificationKey = JSON.stringify([
      origin,
      row
        .filter((f) => f.key !== '数量' && f.key !== '合計重量' && f.key !== '合計体積' && f.key !== '到着予定時刻')
        .map((f) => `${f.key}:${f.value}:${f.klass}`)
        .join('|'),
    ]);

    // 識別キーでグループ化
    if (!groups.has(identificationKey)) {
      groups.set(
        identificationKey,
        { attrs: row.map((f) => ({ ...f })), origin }
      );
    } else {
      // 既存グループの数量・合計重量・合計体積を合算
      const existing = groups.get(identificationKey)?.attrs;
      if (existing) {
        row.reduce((_, thisField) => {
          const field = existing.find((f) => f.key === thisField.key);
          if (field && ['数量', '合計重量', '合計体積', '伝票数'].includes(thisField.key)) {
            field.value = String(parseFloat(field.value) + parseFloat(thisField.value));
          }
          return _;
        }, null);
      }
    }
  });

  // マップの値を配列にして返す
  return Array.from(groups.values());
}
